import apiClient from './client';

export const gamesAPI = {
  getAll: (params) => apiClient.get('/games', { params }),
  getOne: (id) => apiClient.get(`/games/${id}`),
  getCoverage: (id, params) => apiClient.get(`/games/${id}/coverage`, { params }),
  getVideoCoverage: (id, params) => apiClient.get(`/games/${id}/video-coverage`, { params }),
  getKickCoverage: (id, params) => apiClient.get(`/games/${id}/kick-coverage`, { params }),
  getSteam: (id, params) => apiClient.get(`/games/${id}/steam`, { params }),
  getConsole: (id) => apiClient.get(`/games/${id}/console`),
  create: (data) => apiClient.post('/games', data),
  update: (id, data) => apiClient.put(`/games/${id}`, data),
  delete: (id) => apiClient.delete(`/games/${id}`),
  enrichGame: (id) => apiClient.post(`/games/${id}/enrich`),
  searchIGDB: (query) => apiClient.get('/games/search/igdb', { params: { query } }),
  linkContent: (id) => apiClient.post(`/games/${id}/link-content`),
  bulkLinkContent: () => apiClient.post('/games/bulk/link-content', {}, { timeout: 120000 }),

  // Upcoming releases
  getUpcoming: (params) => apiClient.get('/games/upcoming', { params }),
  getIGDBDetail: (igdbId) => apiClient.get(`/games/igdb/${igdbId}`),

  // Branding endpoints
  getBranding: (id) => apiClient.get(`/games/${id}/branding`),
  updateBranding: (id, data) => apiClient.put(`/games/${id}/branding`, data),
  resetBranding: (id) => apiClient.delete(`/games/${id}/branding`),
};
